<a href="javascript:void(0)" (click)="onSiteLinkClicked($event)" [tabindex]="0">
	<div class="icon-desc">
		<div [class]="divClass">
			<img
				class="forecast-icon"					
				[src]="imgUrl"
				anima-src="imgUrl"
				alt="pool"
		/></div>
		<span>{{site.SiteName}}</span>
	</div>
	<a [routerLink]="['/siteDetails', site.Identifier]"
		class="material-icons nsw-material-icons" 			
		focusable="false" aria-hidden="true" (click)="onSiteDetailsNavigation(site.Identifier)">
		east
	</a>
</a>

